// ============================================================
// Dashboard Activities Mock Data
// ============================================================

export const mockDashboardActivities = {
  'school-001': [
    { id: 'act-1', type: 'admission', action: 'New student enrolled', details: 'Alice Wang (Grade 5)', time: '1 hour ago' },
    { id: 'act-2', type: 'fee', action: 'Fee payment received', details: '$500 from Jane Smith', time: '3 hours ago' },
    { id: 'act-3', type: 'attendance', action: 'Attendance marked', details: 'Grade 10-A (100% present)', time: '4 hours ago' },
    { id: 'act-4', type: 'academic', action: 'Exam schedule published', details: 'Mid-Term 2025', time: '1 day ago' },
    { id: 'act-5', type: 'staff', action: 'New teacher added', details: 'Mr. Robert Brown', time: '2 days ago' },
  ],
  'school-002': [
    { id: 'act-6', type: 'admission', action: 'New student enrolled', details: 'Michael Chang (Grade 3)', time: '2 hours ago' },
    { id: 'act-7', type: 'fee', action: 'Fee payment received', details: '$300 from Sarah Connor', time: '5 hours ago' },
    { id: 'act-8', type: 'attendance', action: 'Attendance marked', details: 'Grade 8-B (98% present)', time: '6 hours ago' },
  ],
  'school-003': [
    { id: 'act-9', type: 'fee', action: 'Fee payment received', details: '$250 from Tom Harris', time: '30 minutes ago' },
    { id: 'act-10', type: 'attendance', action: 'Attendance marked', details: 'Grade 5-C (95% present)', time: '1 hour ago' },
  ],
};
